type IntlNumberFormatStyle = 'decimal' | 'currency' | 'percent' | 'unit';

const formatPrice = (num: number | null, style: IntlNumberFormatStyle | undefined = 'decimal') => {
    if (!num) return '0';

    return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 2,
        style,
        currency: 'USD',
    }).format(num / 100);
};

export default formatPrice;
